import { useCallback, useRef } from 'react';
import { insertEmoji } from '../utils/emojiCatalog';

/**
 * Emoji an der Cursor-Position eines textarea/input einfügen (Marcel 21.10.2026).
 * Verwendung: const { fieldRef, insert } = useEmojiInsert(value, setValue); <textarea ref={fieldRef} …/>
 * <EmojiPickerButton onPick={insert} />. Der Cursor steht danach hinter dem Emoji.
 */
export function useEmojiInsert<T extends HTMLTextAreaElement | HTMLInputElement>(value: string, setValue: (next: string) => void) {
  const fieldRef = useRef<T | null>(null);
  const insert = useCallback((emoji: string) => {
    const el = fieldRef.current;
    const { text, cursor } = insertEmoji(value, el?.selectionStart ?? null, el?.selectionEnd ?? null, emoji);
    setValue(text);
    if (el) {
      window.requestAnimationFrame(() => {
        try { el.focus(); el.setSelectionRange(cursor, cursor); } catch { /* input type ohne Auswahl */ }
      });
    }
  }, [value, setValue]);
  return { fieldRef, insert };
}

export default useEmojiInsert;
